import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';

import { RootState } from '@/utils/types';
import { EmployeeRequests, GetEmployeeRequestsParams, ShareNowPassState } from './share-now-pass.model';
import { shareNowPassService } from '@/services/share-now-pass/share-now-pass.service';
import { Offers } from '@/services/share-now-pass/share-now-pass.types';
import { isAccessible } from '@/utils/permissions';

class ShareNowPass implements Module<any, RootState> {
  public state: ShareNowPassState = {
    offers: [],
    subscriptions: [],
    employeeRequests: [],
  };

  public namespaced: boolean = true;
  public actions = {
    async loadOffers(context: ActionContext<ShareNowPassState, RootState>, leId: number) {
      try {
        const isCentralPayment = isAccessible('Rentals', context.rootState.users.roles);
        if (!isCentralPayment) {
          return;
        }

        const offers = await shareNowPassService.getOffers(context.rootState.companies.company.companyId, leId);
        context.commit(
          'SET_SHARE_NOW_PASS_OFFERS',
          offers!.filter((i) => i.passType === 'CORPORATE'),
        );
      } catch (error) {
        context.dispatch('app/showServerError', error, { root: true });
      }
    },

    async loadSubscriptions(context: ActionContext<ShareNowPassState, RootState>) {
      try {
        if (context.getters.supportsSNPass) {
          const subscriptions = await shareNowPassService.getSubscriptions(context.rootState.companies.company.companyId);
          context.commit('SET_SHARE_NOW_PASS_SUBSCRIPTIONS', subscriptions);
        }
      } catch (error) {
        context.dispatch('app/showServerError', error, { root: true });
      }
    },

    async loadEmployeeRequests(context: ActionContext<ShareNowPassState, RootState>, getEmployeeRequestsParams: GetEmployeeRequestsParams) {
      try {
        let employeeRequests = await shareNowPassService.getEmployeeRequests(
          context.rootState.companies.company.companyId,
          getEmployeeRequestsParams.activationId,
          getEmployeeRequestsParams.customerIds,
        );
        employeeRequests = employeeRequests.sort((rq1, rq2) => (rq1.employeeRequest.createdDate > rq2.employeeRequest.createdDate ? -1 : 0));

        context.commit('SET_SHARE_NOW_PASS_EMPLOYEE_REQUESTS', employeeRequests);
      } catch (error) {
        context.dispatch('app/showServerError', error, { root: true });
      }
    },
  } as ActionTree<ShareNowPassState, RootState>;

  public getters = {
    hasPass(state: ShareNowPassState) {
      return state.subscriptions.length > 0;
    },
    supportsSNPass(state: ShareNowPassState) {
      return state.offers.length > 0;
    },
  } as GetterTree<ShareNowPassState, RootState>;

  public mutations = {
    SET_SHARE_NOW_PASS_SUBSCRIPTIONS(state: ShareNowPassState, subscriptions: []) {
      state.subscriptions = subscriptions;
    },
    SET_SHARE_NOW_PASS_OFFERS(state: ShareNowPassState, offers: Offers[]) {
      state.offers = offers;
    },
    SET_SHARE_NOW_PASS_EMPLOYEE_REQUESTS(state: ShareNowPassState, employeeRequests: EmployeeRequests[]) {
      state.employeeRequests = employeeRequests;
    },
  } as MutationTree<ShareNowPassState>;
}

export default new ShareNowPass();
